// extracted by mini-css-extract-plugin
export default {"pay-wrapper":"PayReport_pay-wrapper__r0M9c","department":"PayReport_department__VqzIE","name":"PayReport_name__ybFjk","pay":"PayReport_pay__Gt9tS"};